import { render } from "./mvt-welcome.vue?vue&type=template&id=5e43f228"
import script from "./mvt-welcome.js?vue&type=script&lang=js"
export * from "./mvt-welcome.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__